<template>
	<div class="pay-type">
		<el-card class="cartbox" shadow="never">
			<div slot="header">
				<h3>支付方式</h3>
			</div>
			<div style="width: 100%;">
				<el-button type="primary" @click="handleWeChatPay">微信支付</el-button>
                <el-button type="primary" @click="handleAlipay">支付宝支付</el-button>
                <el-button type="primary" @click="handleOfflineTransfer">线下转账</el-button>
			</div>
		</el-card>

        <!-- 支付 -->
        <WeChatPay ref="WeChatPayRef" :total="orderBasic.totalAmount" :orderNum="orderBasic.tradeNo" />
        <Alipay ref="AlipayRef" :total="orderBasic.totalAmount" :orderNum="orderBasic.tradeNo" />
        <OfflineTransfer :orderBasic="orderBasic" />
	</div>
</template>

<script >
import WeChatPay from '@/components/Pay/WeChatPay.vue';
import Alipay from '@/components/Pay/Alipay.vue';
import OfflineTransfer from '@/components/Pay/OfflineTransfer.vue';

export default {
	name: 'PayType',
	props: {
		orderBasic: {
			type: Object,
			required: true
		},
	},
	data() {
		return {};
	},
    components: {
        WeChatPay,
        Alipay,
        OfflineTransfer
    },
    methods: {
        handleWeChatPay() {
            // 处理微信支付逻辑
            // console.log('微信支付');
            this.$refs.WeChatPayRef.payModal = true;
        },
        handleAlipay() {
            // 处理支付宝支付逻辑
            // console.log('支付宝支付');
            this.$refs.AlipayRef.payModal = true;
        },
        handleOfflineTransfer() {
            this.$message.info('待开发，敬请期待');
            // 处理线下转账逻辑
            // console.log('线下转账');
        }
    }
};
</script>


<style scoped lang="less">
.pay-type  {
    margin-bottom: 20px;
    background-color: #FFFFFF;
    box-shadow: 0px 3px 7px 0px rgba(0,122,255,0.1);
    border-radius: 15px;
    h3 {
        margin: 0;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
    }
}
</style>
